import { LoadingButton } from '@mui/lab'
import { Box, FormControl, InputLabel, MenuItem, Select, Stack, TextField, Typography } from '@mui/material'
import React, { useEffect } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { toast } from 'react-toastify'
import { useFetchUpdateUser } from 'src/services/users'
import { useCompaniesStore } from 'src/store/useCompaniesStore'
import { useUsersStore } from 'src/store/users'
// import { useFetchGetCompanies } from ''

const EditUserForm = ({ userId }) => {
  const users = useUsersStore((state) => state.users)
  const handleUsers = useUsersStore((state) => state.handleUsers)
  const companies = useCompaniesStore((state) => state.companies)
  const currentUser = users.find((user) => user.id === userId.id)
  const {
    control,
    handleSubmit,

    // formState: { errors },
  } = useForm({
    defaultValues: {
      username: currentUser.username ?? '',
      company: currentUser.companyClient.id ?? '',
      firstName: currentUser.firstName ?? '',
      lastName: currentUser.lastName ?? '',
      phoneNumber: currentUser.phoneNumber ?? '',
    },
  })
  const { isSuccess, mutateAsync: updateUser, isLoading, variables } = useFetchUpdateUser()

  const onSubmit = (data) => {
    const { username, company, firstName, lastName, phoneNumber } = data
    updateUser({
      id: userId.id,
      data: {
        username,
        company_client: company,
        first_name: firstName,
        last_name: lastName,
        phone_number: phoneNumber,
      },
    })
  }

  useEffect(() => {
    ;(async () => {
      try {
        if (isSuccess) {
          const company = companies.find((company) => company.id === variables.data.company_client)
          const userUpdated = {
            companyClient: { name: company.name, id: company.id },
            email: currentUser.email,
            firstName: variables.data.first_name,
            groups: currentUser.groups,
            id: currentUser.id,
            isActive: currentUser.isActive,
            lastAccess: currentUser.lastAccess,
            lastAccessToken: currentUser.lastAccessToken,
            lastName: variables.data.last_name,
            phoneNumber: variables.data.phone_number,
          }
          handleUsers(users.map((user) => (user.id === userUpdated.id ? userUpdated : user)))
          toast.success('User Updated')
        }
      } catch (error) {
        toast.error('Failed to create user')
      }
    })()
  }, [isSuccess])

  return (
    <Box
      component="form"
      method="post"
      onSubmit={handleSubmit(onSubmit)}
      sx={{ height: '100%', overflowY: 'scroll', position: 'relative' }}
    >
      <Stack spacing={3}>
        <Typography component="h2" variant="h4" textAlign="center">
          Edit user
        </Typography>
        <Controller
          name="username"
          control={control}
          rules={{
            required: 'This field is required',
          }}
          render={({ field }) => <TextField {...field} label="Username" />}
        />
        <Controller
          name="firstName"
          control={control}
          rules={{
            required: 'This field is required',
          }}
          render={({ field }) => <TextField {...field} label="First Name" />}
        />
        <Controller
          name="lastName"
          control={control}
          rules={{
            required: 'This field is required',
          }}
          render={({ field }) => <TextField {...field} label="Last Name" />}
        />
        <Controller
          name="phoneNumber"
          control={control}
          render={({ field }) => <TextField {...field} label="Phone Number" type="number" />}
        />
        <Controller
          name="company"
          control={control}
          render={({ field }) => (
            <FormControl fullWidth>
              <InputLabel>Company</InputLabel>
              <Select {...field} label="group">
                {/* getCompanies */}
                {companies.map((company) => (
                  <MenuItem key={company.id} value={company.id}>
                    {company.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
        />
      </Stack>
      <Box sx={{ width: '100%', position: 'fixed', bottom: 0, left: 0, padding: '10px' }}>
        <LoadingButton fullWidth size="large" type="submit" variant="contained" loading={isLoading}>
          Edit
        </LoadingButton>
      </Box>
    </Box>
  )
}

export default EditUserForm
